import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { visibleMarkersMapSelector } from '../../features/places/placesSlice';
import { mapServiceSelector } from '../../features/map/mapSlice';

import GooglePlaceMarker from './google/GooglePlaceMarker';
import OsmPlaceMarker from './osm/OsmPlacemarker';

const PlaceMarkerOverlay = ({ map }) => {

    const visibleMarkersMap = useSelector(visibleMarkersMapSelector);
    const mapService = useSelector(mapServiceSelector);

    const plotMarkers = useCallback(
        () => {
            return visibleMarkersMap.map(markerId => (
                mapService === 'google' ?
                    <GooglePlaceMarker
                        key={markerId}
                        markerId={markerId}
                        map={map}
                    />
                    :
                    <OsmPlaceMarker
                        key={markerId}
                        markerId={markerId}
                    />
            ));
        },
        [visibleMarkersMap, map, mapService],
    );


    return (
        <div>
            {plotMarkers()}
        </div>
    );
}

export default PlaceMarkerOverlay;